<!-- TODO: think if we need to have a more-generic component for similar "Create Item Form components" or "Form components in general" (e.g. "CreatePlaylistForm", "CreateSlideForm", "CreateCampaignForm") — N2M1DR80 -->

<template>
  <div class="form">
    <div class="status-bar-container">
      <StatusBar
        :errorMessage="errorMessage"
        :isLoading="/* true ||  */isLoading"
        loadingMessage="Saving..."
        :isSuccess="isSuccess"
        successMessage="Saved!"
      />
    </div>
    <div class="form-fields">
      <ResponsiveTable style="margin-bottom: 0;">
        <!-- Name -->
        <Cell class="flex" :width="`8rem`">
          <LabelCustomized label="Name" />
        </Cell>
        <Cell class="flex items-center" :width="`20rem`">
          <TextField
            name="name"
            v-model="values.name"
            required
            class="field"
            width="40ch"
          />
        </Cell>
      </ResponsiveTable>

      <!-- Basic Fields -->
      <BindingFields v-model="values.sideFeatureBindingOptions" />

      <!-- Separator -->
      <div class="mt-2 h-2 w-11"></div>

      <!-- Players Filters -->
      <PageSection>
        <PlayersFilters v-model="values.filters" />
      </PageSection>
    </div>
    <div class="form-buttons">
      <ButtonCustomized label="Cancel" @click="onCancel" :secondary="true" />
      <ButtonCustomized label="Create" @click="onSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BindingFields from "@/views/LiveStreamEditorView/BindingFields.vue";
import TextField from "@/components/form-fields/TextField.vue";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import { ResponsiveTable } from '@/components/ResponsiveTable';
import Cell from '@/components/ResponsiveTable/Cell.vue';
import LabelCustomized from '@/components/form-fields/LabelCustomized/LabelCustomized.vue';
import PlayersFilters from "@/views/PlayerSubscriptionEditorView/PlayersFilters/PlayersFilters.vue";
import PageSection from '@/components/layouts/PageSection.vue';

import { useCreateLiveStreamFormHelpers } from "./composables/createLiveStreamFormHelpers";
import useNotifications from "@/components/Notifications/composables/notifications";

import router from '@/router';
import { ref } from "vue";


const emit = defineEmits(['submit', 'cancel', 'success', 'fail'])
const notification = useNotifications();

const {
  values,
  submitForm,
  isLoading,
  isSuccess,
  errorMessage,
  newSubscriptionId,
} = useCreateLiveStreamFormHelpers();

async function onSubmit() {
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Live Stream created and start stream command sent successfully to players!');
    emit('success');
    router.push({name: 'live-stream-editor', params: {id: newSubscriptionId.value}});
  } else {    // on failure
    emit('fail');
  }
}

function onCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>

.status-bar-container {
  margin-bottom: 1rem;
}

.form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  :deep(label) {
    width: 8rem !important;
  }
}

.field {
  :deep(label) {
    width: 110px;
  }
  :deep(.select) {
    width: 60%;
  }
}
.formGroup {
  display: flex;
  align-items: center;
  .select {
    width: 60%;  // 
    margin: 0;
  }
  label {
    display: inline-block;
    width: 110px; //
    color: #262626;
    font-weight: bold;
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
